export type ContentPage = 'start' | 'info' | 'pre-form' | 'form' | 'summary';

// Languages supported by HTA Connector
export type Language = 'fi' | 'sv' | 'en';
export const languages: Language[] = ['fi', 'sv', 'en'];

export type DeviceInfo = 'TT-Online' | 'TT-App';

export type ownApiAnswer = {
  id?: number;
  choice?: AnswerChoice;
  durationOfSymptoms?: string;
  moreInformationAboutSymptom?: string;
};

export type ownApiAnswerWithValidation = ownApiAnswer & { isValid: boolean };

// ApiAnswer symptomDuration
export enum SymptomDuration {
  underOne = 'underOne',
  oneToTwo = 'oneToTwo',
  twoToThree = 'twoToThree',
  overThree = 'overThree',
}

// ApiAnswerChoice yes, no or don't know
export enum AnswerChoice {
  yes = 'yes',
  no = 'no',
  dontKnow = 'dontKnow',
}

// HTA questionnaire currently only supports male and female genders
export type Gender = 'male' | 'female' | undefined;
